var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "queryRecord" },
    [
      _c("notice", { attrs: { showIcon: "" } }, [
        _vm._v("温馨提示：排名查询记录只保留"),
        _c("em", { staticClass: "orangeFont" }, [_vm._v(" 15 ")]),
        _vm._v("，15天后系统将自动清除，请及时查看记录"),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "query-Record-content",
        },
        [
          _c(
            "div",
            { staticClass: "searchBar dfc" },
            [
              _c(
                "div",
                { staticClass: "search-item" },
                [
                  _c("span", [_vm._v("关键词：")]),
                  _c("el-input", {
                    staticClass: "w220",
                    attrs: { size: "small", placeholder: "请输入关键词" },
                    model: {
                      value: _vm.keyWord,
                      callback: function ($$v) {
                        _vm.keyWord = $$v
                      },
                      expression: "keyWord",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "search-item ml20" },
                [
                  _c("span", [_vm._v("类型：")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "w220",
                      attrs: { size: "small" },
                      model: {
                        value: _vm.searchType,
                        callback: function ($$v) {
                          _vm.searchType = $$v
                        },
                        expression: "searchType",
                      },
                    },
                    _vm._l(_vm.searchTypeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "search-item ml20" },
                [
                  _c("span", [_vm._v("查询时间：")]),
                  _c("el-date-picker", {
                    attrs: {
                      size: "small",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "picker-options": _vm.pickerOptions,
                    },
                    model: {
                      value: _vm.dateRangeTime,
                      callback: function ($$v) {
                        _vm.dateRangeTime = $$v
                      },
                      expression: "dateRangeTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "ml20 w120",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.search },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table mt20" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    stripe: "",
                    "header-cell-style": _vm.tableHeader,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "查询时间" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("formatTime")(row.createTime))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [_vm._v(_vm._s(row.queryTypeText))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "关键词", "min-width": "260" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(row.keyWords.join("，"))),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "查询页数" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  row.queryPage === 1 ? "1-60个" : "1-200个"
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "产品链接" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "textOver",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  title: row.queryLink ? row.queryLink : "--",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.queryLink ? row.queryLink : "--"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "店铺名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(row.shopName ? row.shopName : "--")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      align: "center",
                      "header-align": "center",
                      width: "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.checkDetail(row)
                                  },
                                },
                              },
                              [_vm._v("查看详情")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tr mt10" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.query.pageIndex,
                      "page-size": _vm.query.pageSize,
                      background: "",
                      layout: "prev, pager, next,total, jumper",
                      total: _vm.query.totalCount,
                    },
                    on: { "current-change": _vm.handleCurrentChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("checkDetail", { ref: "checkDetail" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }